import { Component, computed, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WalletService } from '../services/wallet.service';
import { MusicService } from '../services/music.service';

@Component({
  selector: 'app-login',
  imports: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit, OnDestroy {
  private readonly walletService = inject(WalletService);
  private readonly musicService = inject(MusicService);
  private readonly router = inject(Router);

  protected readonly walletConnection = computed(() => this.walletService.walletConnection());
  protected readonly isConnecting = computed(() => this.walletService.isLoadingNFTs());

  async connectWallet(): Promise<void> {
    this.walletService.connectWallet().then(() => {
      if (this.walletConnection()) {
        this.router.navigate(['/home']);
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.musicService.startBackgroundMusic('/assets/audio/slow_8_Bit_Menu.mp3');
    this.walletService.restoreWalletConnection().then(() => {
      if (this.walletConnection()) {
        this.router.navigate(['/home']);
      }
    });
  }

  ngOnDestroy(): void {
    this.musicService.stopBackgroundMusic();
  }
}
